import { MirrorDetails } from 'store/declarations/declaration';

export const getMirrorDucr = (mirrorDetails?: MirrorDetails): string | undefined => {
    if (!mirrorDetails?.ducrBase) return undefined;

    const part = mirrorDetails.ducrPart ?? mirrorDetails.index;

    return `${mirrorDetails.ducrBase}/${part}`;
};
